import {InjectionToken} from '@angular/core';

/**
 * Host of an im.ImSystem `url` (lower case, no scheme, no port, no path) → absolute base URL of the
 * app that should open the customer instead, e.g.
 * `{'fku-klaus.alpha-platform.cloud': 'https://co-klaus.alpha-platform.cloud'}`.
 *
 * <p>Used by the consultant customer header („External Partners" popover): the stored system URL
 * points at the FKU app of the other tenant, but a consultant must land in that tenant's consultant
 * app. A system whose host has no entry gets no link.
 */
export type CrExternalSystemLinks = Readonly<Record<string, string>>;

/**
 * The link table of the running environment. The consultant shell provides it in app.module.ts from
 * `environment.externalSystemLinks`; every other shell falls back to the empty table, i.e. no link.
 */
export const CR_EXTERNAL_SYSTEM_LINKS = new InjectionToken<CrExternalSystemLinks>(
    'CR_EXTERNAL_SYSTEM_LINKS',
    {factory: () => ({})}
);
